
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import SubscriptionPlans from "./SubscriptionPlans";
import PremiumFeatures from "./PremiumFeatures";

const PlanTabs = () => {
  const { language } = useLanguage();
  
  return (
    <Tabs defaultValue="plans" className="w-full mb-12">
      <TabsList className="grid w-full max-w-md mx-auto grid-cols-2">
        <TabsTrigger value="plans">{t('premium.subscriptionPlans', language)}</TabsTrigger>
        <TabsTrigger value="features">{t('premium.premiumFeatures', language)}</TabsTrigger>
      </TabsList>
      
      <TabsContent value="plans" className="mt-6">
        <SubscriptionPlans />
      </TabsContent>
      
      <TabsContent value="features" className="mt-6">
        <PremiumFeatures />
      </TabsContent>
    </Tabs>
  );
};

export default PlanTabs;
